import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchMyPricePointMix = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.myPricePointMix;
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.instant.myPricePointMix';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/my-price-point-mix.api.js